import React, { useState } from "react";
import "../css/ForgetPassword.css";
import { doPasswordReset } from "../config/auth";
import { useNavigate } from "react-router-dom";

const ForgetPassword = () => {
	const navigate = useNavigate();

	const [email, setEmail] = useState("");
	const [error, setError] = useState("");
	const [success, setSuccess] = useState("");
	const [loading, setLoading] = useState(false);

	const handleReset = async (e) => {
		e.preventDefault();
		setError("");
		setSuccess("");

		if (!email) {
			setError("Please enter your email");
			return;
		}

		try {
			setLoading(true);
			await doPasswordReset(email);

			setSuccess("Password reset link sent to your email 📧");
		} catch (err) {
			console.error(err);

			if (err.code === "auth/user-not-found") {
				setError("No account found with this email");
			} else if (err.code === "auth/invalid-email") {
				setError("Invalid email address");
			} else {
				setError("Something went wrong. Try again.");
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="forgot-container">
			<form className="forgot-card" onSubmit={handleReset}>
				<h2>Forgot Password</h2>
				<p>Enter your registered email</p>

				{error && <p className="forgot-error">{error}</p>}
				{success && <p className="forgot-success">{success}</p>}

				<input
					type="email"
					placeholder="Email address"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/>

				<button type="submit" disabled={loading}>
					{loading ? "Sending..." : "Send Reset Link"}
				</button>

				<span className="back-login" onClick={() => navigate("/login")}>
					Back to Login
				</span>
			</form>
		</div>
	);
};

export default ForgetPassword;
